import { Text, TextProps } from "@aksara-ui/react";
import React from "react";

interface PaginationDetailProps extends TextProps {
  page: number;
  limit: number;
  length: number;
}

const PaginationDetail: React.FC<PaginationDetailProps> = ({
  page,
  limit,
  length,
  scale = [300],
  ...rest
}) => {
  return (
    <Text scale={scale} {...rest}>{`Showing ${(page - 1) * limit + 1}-${
      limit * page < length ? limit * page : length
    } out of ${length}`}</Text>
  );
};

export default PaginationDetail;
